<template>
  <Layout>
    <PageHeader v-if="title" :title="title" :items="items" />
    <div v-if="stats.length" class="row">
      <div v-for="stat of stats" :key="stat.icon" :class="stat.wrapperClass || 'col-6 col-md-4 col-xl-3'">
        <Stat v-bind="stat" :loading="busy" />
      </div>
    </div>
    <Loader no-axios>
      <div v-if="!lodash.isEmpty(filterColumns)" class="row">
        <model-filter
          v-model="filter"
          :columns="filterColumns"
          :modelVariable="modelVariable"
          :filterHandler="filterHandler"
        />
      </div>
      <div class="row">
        <model-index
          ref="table"
          :actions="actions"
          :action-buttons="actionButtons"
          class="col-12"
          :loading="loading"
          v-bind="$props"
          :columns="columns"
          :busy.sync="busy"
          :models-paginated="modelsPaginated"
          :page.sync="page"
          :per-page.sync="perPage"
          :from="from"
          :total="totalFiltered"
          :search.sync="search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter-params.sync="filterParams"
          @create-click="handleCreate"
          @export-click="handleExport"
          @show-click="handleShow"
          @edit-click="handleEdit"
          @delete-click="handleDelete"
        >
          <template #card-tools>
            <b-button
              v-if="!denyExport"
              class="me-2"
              size="lg"
              variant="success"
              @click="$bvModal.show('sales-report-export-modal')"
            >
              <span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.464 0C14.176 0 16 1.904 16 4.728V11.264C16 14.096 14.176 16 11.464 16H4.528C1.8168 16 0 14.096 0 11.264V4.728C0 1.904 1.8168 0 4.528 0H11.464ZM8 4.136C7.664 4.136 7.4 4.4 7.4 4.736V9.816L5.424 7.832C5.312 7.72 5.152 7.656 5 7.656C4.8488 7.656 4.696 7.72 4.576 7.832C4.344 8.064 4.344 8.448 4.576 8.68L7.576 11.696C7.8 11.92 8.2 11.92 8.424 11.696L11.424 8.68C11.656 8.448 11.656 8.064 11.424 7.832C11.184 7.6 10.808 7.6 10.568 7.832L8.6 9.816V4.736C8.6 4.4 8.328 4.136 8 4.136Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span style="font-size: 14px;">
                Unduh Laporan
              </span>
            </b-button>
            <b-button
                variant="primary"
                size="lg"
                class="me-2"
                @click="onClickSyncUpdatedToday"
                style="font-size: 14px"
                v-if="$auth.hasPermissionTo('odoo_sale_orders.sync')"
            >
              {{ lodash.upperFirst($t('sale_notes.odoo_sale_orders.sync_updated_today_button_text')) }}
            </b-button>
            <export-modal
              id="sales-report-export-modal"
              :title="`${lodash.upperFirst($t('download'))} ${$t('report')}`"
              title-class="font-18"
              size="sm"
              hide-footer
            >
              <div class="row m-0" style="background-color: #F5F6F7; border-radius: 10px; border: 1px solid #CCCCCC;">
                <div class="col-6" style="padding: 5px 2px 5px 5px">
                  <b-button
                    block
                    :class="{ 'btn btn-export-file btn-excel': true, active: activePillButton === 'excel' }"
                    style="padding: 11px 13px; height: 100%"
                    @click="activePillButton = 'excel'"
                  >
                    <icon-base v-if="activePillButton === 'excel'" class="me-2" width="21px" height="21px">
                      <file-excel-icon />
                    </icon-base>
                    <icon-base v-else class="me-2" width="21px" height="21px">
                      <file-excel-dark-icon />
                    </icon-base>
                    Excel
                  </b-button>
                </div>
                <div class="col-6" style="padding: 5px 5px 5px 2px">
                  <b-button
                    block
                    :class="{ 'btn btn-export-file btn-pdf': true, active: activePillButton === 'pdf' }"
                    style="padding: 11px 13px; height: 100%"
                    @click="activePillButton = 'pdf'"
                  >
                    <i class="fa fa-file-pdf me-2"></i>PDF
                  </b-button>
                </div>
              </div>
              <b-form-group
                id="ordered-at-input-group"
                :label="lodash.upperFirst($t('sale_notes.sales_date'))"
                label-for="ordered-at-input"
                style="color: #6C7589; margin-top: 16px"
                :state="isExportOrderedAtValid"
                :invalid-feedback="
                  `*${$t('sale_notes.exports.validations.ordered_at {range}', {
                    range: `3 ${lodash.lowerCase($t('Month'))}`
                  })}`
                "
              >
                <datepicker-range
                  name="ordered_at"
                  v-model="exportOrderedAt"
                  :shortcuts="exportOrderedAtShorcuts"
                  :state="isExportOrderedAtValid"
                ></datepicker-range>
              </b-form-group>
              <div style="display: flex; justify-content: space-between; padding-top: 16px">
                <div style="width: 46%; float: left">
                  <b-button block variant="outline-dark" @click="$bvModal.hide('sales-report-export-modal')">{{
                    $t("Cancel")
                  }}</b-button>
                </div>
                <div style="width: 46%">
                  <b-button
                    block
                    variant="primary"
                    type="submit"
                    :disabled="!isExportOrderedAtValid || loadingExport"
                    @click="onSubmitExport"
                  >
                    <i v-if="loadingExport" class="bx bx-loader bx-spin me-2"></i>
                    {{ $t("Export") }}
                  </b-button>
                </div>
              </div>
            </export-modal>

          </template>
        </model-index>
        <component v-bind:key="modal" v-for="modal in modals" v-bind:is="modal"></component>
        <!-- <down-payment-form-modal -->
      </div>
    </Loader>
  </Layout>
</template>
<script>
import ModelFilter from "@/router/views/sale_notes/filter";
import ModelIndex from "../models/index-v3";
import DatepickerRange from "@/components/inputs/filter/datepicker-range";
import ExportModal from "./index/export-modal";
import FileExcelIcon from "@/components/icons/FileExcel";
import FileExcelDarkIcon from "@/components/icons/FileExcelDark";
import PillButton from "./show/pill-button";
import DatePicker from "vue2-datepicker";
import Swal from "sweetalert2";
import IconBase from "@/components/icon-base";
import StatusWidget from "@/components/widgets/statuses/status";
import StatusTonWidget from "@/components/widgets/statuses/status-with-ton";
import StatusDateWidget from "@/components/widgets/statuses/status-with-date";
import PageHeader from "@/components/page-header.vue";

export default {
  extends: ModelIndex,
  components: {
    PageHeader,
    DatepickerRange,
    ExportModal,
    FileExcelIcon,
    FileExcelDarkIcon,
    IconBase,
    ModelFilter,
    PillButton,
    DatePicker,
    StatusWidget,
    StatusTonWidget,
    StatusDateWidget
  },
  page: {
    title: "Sale Notes"
  },
  props: {
    // cardTitle: {default() { return this.lodash.startCase(this.$t('sale_notes.plural')) }},
    resourceRoute: { default: "sale_notes" },
    modelVariable: { default: "sale_note" },
    denyCreate: { type: Boolean, default: true },
    denyExport: {default() {
      return !this.$auth.hasPermissionTo("sale_reports.export")
    }},
    actionButtonProps: {
      type: Array,
      default() {
        return [
          {
            label: this.lodash.startCase(this.$t("sale_notes.resumes.singular")),
            action: item => {
              this.$router.push({
                name: "sale_notes.show",
                params: {
                  key: item.id
                },
                query: {
                  redirectTo: "resume"
                }
              });
            },
            disable: () => false,
          }
        ];
      }
    },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t("sale_notes.plural")),
      items: [
        {
          text: this.lodash.startCase(this.$t("sale_notes.plural")),
          href: "/sale_notes",
          active: true
        }
      ],
      sortBy:
        (this.$route.query.sort &&
          this.$route.query.sort
            .split("|")
            .shift()
            .split(",")
            .shift()) ||
        "id",
      sortDesc:
        (this.$route.query.sort &&
          this.$route.query.sort
            .split("|")
            .shift()
            .split(",")
            .pop() === "desc") ||
        true,
      filterColumns: {
        id__in: {
          type: Array,
          label: this.lodash.startCase(this.$t(`${this.resourceRoute}.id`)),
          placeholder: "Pilih " + this.lodash.startCase(this.$t(`${this.resourceRoute}.id`)),
          operator: "in",
          input_component: "sale-order-multiselect-ajax",
          searchKey: "id",
          customLabel: function(value) {
            return `${value.type_name}-${value.id}`;
          }
        },
        customer_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("customers.types.processing")),
          placeholder: this.$t("Select {something}", {something: this.lodash.upperFirst(this.$t("customers.types.processing"))}),
          operator: "in",
          input_component: "processing-customer-multiselect-ajax"
        },
        ticket_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("sale_notes.ticket_id")),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t("sale_notes.ticket_id")),
          operator: "in",
          input_component: "ticket-multiselect-ajax"
        },
        where_has_purchase_order_customer_id__in: {
          type: Array,
          label: this.lodash.startCase(this.$t(`${this.resourceRoute}.partner`)),
          placeholder: "Pilih " + this.lodash.startCase(this.$t(`${this.resourceRoute}.partner`)),
          input_component: "supplier-multiselect-ajax"
        },
        where_has_purchase_order_ordered_at__between: {
          type: Array,
          label: this.lodash.startCase(this.$t(`${this.resourceRoute}.harvest_ordered_at`)),
          placeholder: "Pilih " + this.lodash.startCase(this.$t(`${this.resourceRoute}.harvest_ordered_at`)),
          input_component: "datepicker-range"
        },
        sale_item_total_initial_quantity__between: {
          type: Array,
          label: this.lodash.startCase(this.$t(`${this.resourceRoute}.harvest_biomass`)),
          operator: "between",
          input_component: "number-range"
        },
        sale_item_total_quantity__between: {
          type: Array,
          label: this.lodash.startCase(this.$t(`${this.resourceRoute}.sales_quantity`)),
          operator: "between",
          input_component: "number-range"
        },
        total__between: {
          type: Array,
          label: this.lodash.startCase(this.$t(`${this.resourceRoute}.sales_total`)),
          operator: "between",
          input_component: "number-range"
        },
        ordered_at__between: {
          type: Array,
          label: this.lodash.startCase(this.$t(`${this.resourceRoute}.sales_date`)),
          placeholder: "Pilih " + this.lodash.startCase(this.$t(`${this.resourceRoute}.sales_date`)),
          operator: "between",
          input_component: "datepicker-range"
        },
        odoo_sale_order_state: {
          type: String,
          label: this.lodash.startCase(this.$t("sale_notes.odoo_sale_orders.state")),
          placeholder: "Pilih " + this.lodash.startCase(this.$t("sale_notes.odoo_sale_orders.state")),
          input_component: "odoo-sale-order-state-select"
        },
        odoo_sale_order_invoice_status: {
          type: String,
          label: this.lodash.startCase(this.$t("sale_notes.odoo_sale_orders.invoice_status")),
          placeholder: "Pilih " + this.lodash.startCase(this.$t("sale_notes.odoo_sale_orders.invoice_status")),
          input_component: "odoo-sale-order-invoice-status-select"
        }
      },
      exportOrderedAt: [
        this.$moment()
          .startOf("months")
          .toDate(),
        this.$moment()
          .endOf("months")
          .toDate()
      ],
      orderedAtState: null,
      activePillButton: "excel",
      loadingExport: false
    };
  },
  computed: {
    actions() {
      return [
        {
          component: {
            data() {
              return {
                // icons
              };
            },
            methods: {
              showModal() {
                this.$emit("handle-export");
                // this.handleExport()
              }
            },
            template: `
                <b-button
                  v-if="!denyExport"
                  variant="success"
                  size="lg"
                  class="me-2"
                  @click="showModal"
                  v-b-tooltip.hover title="Unduh laporan penjualan"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.2682 1.51554L12.8177 4.06763C12.8481 4.09802 12.875 4.13122 12.8982 4.16659H12.7188H12.7186H12.2098M10.2682 1.51554C10.2371 1.48442 10.203 1.45697 10.1667 1.43343V1.617L10.2682 1.51554ZM10.2682 1.51554L10.1667 1.61711V2.12135M10.1667 2.12135L9.91468 1.8691C9.91463 1.86905 9.91458 1.86901 9.91454 1.86896C9.89241 1.84691 9.86133 1.83325 9.82552 1.83325H9.66667V4.16659H10.1667M10.1667 2.12135L12.2098 4.16659M10.1667 2.12135V4.16659M10.1667 4.16659V4.66659H12.5V4.50773C12.5 4.47556 12.4871 4.44409 12.4642 4.42118L12.464 4.421L12.2098 4.16659M10.1667 4.16659H12.2098M3.625 1.83325H8.33333V4.87492C8.33333 5.49481 8.83844 5.99992 9.45833 5.99992H12.5V14.0416C12.5 14.1118 12.4452 14.1666 12.375 14.1666H3.625C3.55479 14.1666 3.5 14.1118 3.5 14.0416V1.95825C3.5 1.88804 3.55479 1.83325 3.625 1.83325Z" fill="white" stroke="white"/>
                    <path d="M8.00051 7.45703H10.9982C11.161 7.45703 11.293 7.58904 11.293 7.75187V9.24262M8.00051 7.45703H5.00285C4.84001 7.45703 4.70801 7.58904 4.70801 7.75187V9.24262M8.00051 7.45703V9.24262M8.00051 12.747H5.00285C4.84001 12.747 4.70801 12.615 4.70801 12.4521V10.9948M8.00051 12.747H10.9982C11.161 12.747 11.293 12.615 11.293 12.4521V10.9948M8.00051 12.747V10.9948M4.70801 9.24262H8.00051M4.70801 9.24262V10.9948M8.00051 9.24262V10.9948M8.00051 9.24262H11.293M11.293 9.24262V10.9948M11.293 10.9948H8.00051M8.00051 10.9948H4.70801" stroke="#1DA62B" stroke-width="0.75" stroke-linejoin="round"/>
                  </svg>
                </b-button>
              `
          }
        },
        {
          component: {
            data() {
              return {
                // icons
              };
            },
            methods: {
              failedAlert() {
                return Swal.fire({
                  title: this.$t("Failed") + "!",
                  text: 'Failed to sync odoo purchase order updated today ',
                  type: "danger",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              },
              onClickSyncUpdatedToday() {
                return this.$axios.post('/v1/purchase_orders/updated_today/sync_from_odoo')
                    .then(() => {
                      return this.syncUpdatedTodayQueueInProgressAlert();
                    })
                    .catch(e => this.failedAlert(e))
              },
              syncUpdatedTodayQueueInProgressAlert() {
                return Swal.fire({
                  title: `Sync Odoo Purchase Order in Progress`,
                  type: "primary",
                  confirmButtonClass: "btn btn-success",
                  confirmButtonText: this.$t("ok"),
                  buttonsStyling: false
                }).then((res) => {
                  if (res.isConfirmed) {
                    this.$router.go(0)
                  }
                });
              },
            },

            template: `
                <b-button
                  variant="primary"
                  size="lg"
                  class="me-2"
                  @click="onClickSyncUpdatedToday"
                  style="font-size: 14px"
                >
                  {{ lodash.upperFirst($t('purchase_orders.odoo_purchase_orders.sync_updated_today_button_text')) }}
                </b-button>
              `
          }
        },
      ];
    },
    actionButtons() {
      return [
        ...this.actionButtonProps,
        {
          key: 'resend-so-to-odoo',
          action: (v) => this.handleSyncToOdoo(v),
          label: 'Sinkron ke Odoo',
          disable: (v) => {
            let vendorHasOdooPartnerId = v.customer?.odoo_partner_id
            if (!vendorHasOdooPartnerId) return true

            return !!v.odoo_sale_order?.odoo_sale_order_id
          },
          hide: () => {
            return !this.$auth.hasPermissionTo("odoo_sale_orders.sync");
          }
        },
      ]
    },
    isModelEmpty() {
      return this.models.length === 0;
    },
    columns() {
      return {
        ["sale_note"]: [
          {key: "index", label: "No", sortable: false, style: {width: "1%"}},
          {
            key: "ticket_id",
            label: this.lodash.startCase(this.$t("tickets.ticket_id")),
            thStyle: { width: "125px" },
            sortable: true,
            component: {
              props: ["item"],
              computed: {
                customLabel() {
                  return `${this.item.ticket_id}: ${this.$t(
                    `tickets.customer_types.${this.item.ticket.customer_type}`
                  )}`;
                }
              },
              template: '<router-link :to="`/tickets/${(item || {}).ticket_id}`">{{ customLabel }}</router-link>'
            }
          },
          {
            key: "id",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.id`)),
            sortable: true,
            thStyle: { width: "150px" },
            component: {
              props: ["item"],
              computed: {
                customLabel() {
                  return `${this.item.type_name}-${this.item.id}`;
                }
              },
              template: /*html*/ `
                <div>{{ customLabel }}</div>`
            }
          },
          {
            key: "partner_names",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.partner`)),
            sortable: false,
            style: { width: "175px" },
            component: {
              props: ["item"],
              computed: {
                partnerName() {
                  // if the partner name contains "ke" then the format willbe
                  // <partner_name> ke \n<partner_name>
                  // so, just add \n after "ke"
                  if (this.item.partner_names.includes("ke")) {
                    return this.item.partner_names.replace("ke", "ke<br>");
                  }
                  return this.item.partner_names;
                }
              },
              template: /*html*/ `
                <div>
                  <div v-html="partnerName"></div>
                </div>
              `
            }
          },
          {
            key: "total_cost_of_goods_sold",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.COGS`)),
            sortable: false,
            tdClass: { "text-end": true },
            style: { width: "140px" },
            formatter: value => this.$numeral(value).format("$ 0,0.[00]")
          },
          {
            key: "gross_profit",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.shows.gross_profit`)),
            sortable: false,
            style: { width: "125px" },
            tdClass: { "text-end": true },
            component: {
              props: ["item"],
              computed: {
                grossProfitMargin() {
                  return this.item.gross_profit / this.item.total_revenue;
                }
              },
              template: /*html */ `
                <div>
                  <div>
                    {{ $numeral(item.gross_profit).format('$ 0,0.[000]') }}
                  </div>
                  <div
                    :class="{'text-success': grossProfitMargin > 0, 'text-danger': grossProfitMargin < 0}"
                  >
                    {{ $numeral(grossProfitMargin).format('0,0.[000]%') }}
                  </div>
                </div>
              `
            }
          },
          {
            key: "sale_item_total_quantity",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.sales_quantity`)),
            tdClass: "text-end",
            sortable: true,
            style: { width: "100px" },
            formatter: value =>
              value >= 500
                ? `${this.$numeral(value / 1000).format("0,0.[000]")} ${this.$t("units.ton")}`
                : `${this.$numeral(value).format("0,0.[000]")} ${this.$t("units.kg")}`
          },
          {
            key: "total",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.sales_total`)),
            tdClass: "text-end",
            sortable: true,
            style: { width: "150px" },
            formatter: value => this.$numeral(value).format("$ 0,0.[000]")
          },
          {
            key: "ordered_at",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.sales_ordered_at`)),
            sortable: true,
            formatter: value => (value ? this.$moment(value).format("DD MMM YYYY") : "-")
          },
          {
            key: 'odoo_sale_order.state',
            label: this.lodash.startCase(this.$t("sale_notes.odoo_sale_orders.state")),
            component: {
              props: ["item"],
              computed: {
                translatedState() {
                  let state = this.item.odoo_sale_order?.state
                  if (!state) {
                    return '-'
                  }
                  return this.$t(`sale_notes.odoo_sale_orders.states.${state}`)
                },
                badgeClass() {
                  let state = this.item.odoo_sale_order?.state

                  if (!state) {
                    return {'badge': true, 'bg-light': true}
                  }

                  if (state === 'purchase') {
                    return {'status-badge': true, 'badge': true, 'bg-success': true}
                  }  else if (state === 'to approve') {
                    return {'badge': true, 'bg-warning': true}
                  }

                  return {'badge': true, 'bg-light': true}
                },
              },
              template:`
                <status-badge
                    v-if="translatedState != '-'"
                    entity="odoo_sale_order"
                    type="status"
                    :status="item.odoo_sale_order.state"
                ></status-badge>
                <span v-else>-</span>
              `
            },
          },
          {
            key: 'odoo_sale_order.invoice_status',
            label: this.lodash.startCase(this.$t("sale_notes.odoo_sale_orders.invoice_status")),
            component: {
              props: ["item"],
              computed: {
                translatedInvoiceStatus() {
                  let invoiceStatus = this.item.odoo_sale_order?.invoice_status
                  if (!invoiceStatus) {
                    return '-'
                  }
                  return this.$t(`sale_notes.odoo_sale_orders.invoice_statuses.${invoiceStatus}`)
                },
                badgeClass() {
                  let invoiceStatus = this.item.odoo_sale_order?.invoice_status

                  if (!invoiceStatus) {
                    return {'badge': true, 'bg-light': true}
                  }

                  if (invoiceStatus === 'invoiced') {
                    return {'status-badge': true, 'badge': true, 'bg-success': true}
                  }  else if (invoiceStatus === 'to invoice') {
                    return {'badge': true, 'bg-warning': true}
                  }

                  return {'badge': true, 'bg-light': true}
                },
              },
              template:`
                <status-badge
                    v-if="translatedInvoiceStatus != '-'"
                    entity="odoo_sale_order"
                    type="invoice_status"
                    :status="item.odoo_sale_order.invoice_status"
                ></status-badge>
                <span v-else>-</span>
              `
            },
          },
          {
            key: "odoo_order_name",
            label: 'Nomor SO',
            thStyle: {minWidth: "50px"},
            formatter: value => value ?? '-',
            component: {
              props: ['item'],
              computed: {
                hasOdooOrderId() {
                  return !!this.item.odoo_sale_order?.odoo_sale_order_id
                },
                hasOdooOrder() {
                  return !!this.item.odoo_sale_order
                },
                invoiceNumber() {
                  return this.item.odoo_sale_order?.reference_number
                },
                vendorHasOdooPartnerId() {
                  return !!this.item.customer?.odoo_partner_id
                },
              },
              template: `
                <div>
                  <template v-if="invoiceNumber">{{ invoiceNumber }}</template>
                  <template v-else-if="!vendorHasOdooPartnerId">
                    <i :id="'so-warning-'+item.id" class="fa fa-exclamation-circle" style="color: #ffc107"></i>
                    <b-tooltip placement="top" :target="'so-warning-'+item.id">
                      Pabrik/Pembeli belum terkoneksi dengan Vendor di Odoo
                    </b-tooltip>
                  </template>
                  <template v-else>-</template>
                </div>
              `
            },
          },
          {
            key: 'odoo_sale_order.odoo_sync_status',
            label: this.lodash.upperFirst(this.$t('sale_notes.odoo_sale_orders.latest_odoo_sync_status')),
            thStyle: {minWidth: "25px"},
            formatter: value => this.lodash.upperFirst(
                !value ? this.$t('sale_notes.odoo_sale_orders.odoo_sync_statuses.not_yet_synced') :
                    this.$t(`sale_notes.odoo_sale_orders.odoo_sync_statuses.${value}`)
            ),
          },
          {key: "action", label: this.$t("Action"), class: "text-center", style: {width: "1%"}}
        ]
      };
    },
    exportOrderedAtShorcuts() {
      let today = this.$moment();
      return {
        "7 hari lalu": [
          this.$moment()
            .subtract(7, "days")
            .add(1, "days")
            .toDate(),
          today.toDate()
        ],
        "Bulan ini": [
          this.$moment()
            .startOf("months")
            .toDate(),
          this.$moment()
            .endOf("months")
            .toDate()
        ],
        "1 bulan lalu": [
          this.$moment()
            .subtract(1, "months")
            .add(1, "days")
            .toDate(),
          today.toDate()
        ],
        "Kuartal ini": [
          this.$moment()
            .startOf("quarter")
            .toDate(),
          this.$moment()
            .endOf("quarter")
            .toDate()
        ]
      };
    },
    exportDatesLabel() {
      return this.exportOrderedAt.map(value => this.$moment(value).format("DD MMM YYYY")).join(" - ");
    },
    isExportOrderedAtValid() {
      if (!this.exportOrderedAt.length) return false;
      let endDateMoment = this.$moment(this.exportOrderedAt[1]);
      let startDateMoment = this.$moment(this.exportOrderedAt[0]);
      return endDateMoment.diff(startDateMoment, "months", true) <= 3;
    }
  },
  watch: {
    selectedExportOption: function(val, oldVal) {
      if (val !== oldVal) {
        if (val === "weeks") {
          this.exportDates = [
            this.$moment()
              .subtract(6, "days")
              .toDate(),
            this.$moment().toDate()
          ];
        } else if (val === "months") {
          this.exportDates = [
            this.$moment()
              .subtract(1, val)
              .toDate(),
            this.$moment().toDate()
          ];
        } else if (val === "quarters") {
          this.exportDates = [
            this.$moment()
              .startOf(val)
              .toDate(),
            this.$moment()
              .endOf(val)
              .toDate()
          ];
        }
      }
    }
  },
  methods: {
    failedUpdatedTodayAlert() {
      return Swal.fire({
        title: this.$t("Failed") + "!",
        text: 'Failed to sync odoo sale order updated today ',
        type: "danger",
        confirmButtonClass: "btn btn-danger btn-fill",
        buttonsStyling: false
      });
    },
    onClickSyncUpdatedToday() {
      return this.$axios.post('/v1/sale_orders/updated_today/sync_from_odoo')
          .then(() => {
            return this.syncUpdatedTodayQueueInProgressAlert();
          })
          .catch(e => this.failedUpdatedTodayAlert(e))
    },
    syncUpdatedTodayQueueInProgressAlert() {
      return Swal.fire({
        title: `Sync Odoo Sale Order in Progress`,
        type: "primary",
        confirmButtonClass: "btn btn-success",
        confirmButtonText: this.$t("ok"),
        buttonsStyling: false
      }).then((res) => {
        if (res.isConfirmed) {
          this.$router.go(0)
        }
      });
    },
    delete(value) {
      return this.$axios.delete(`/sale_orders/${this.getModelKey(value)}`);
    },
    fetchModels(page = 1) {
      return this.$axios
        .get("/sale_orders", {
          params: {
            page: page,
            per_page: this.perPage,
            search: this.search,
            sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
            with: [
              "customer",
              "odoo_sale_order.odoo_sale_order_lines",
              "purchase_order.customer",
              "purchase_order.farmer",
              "purchase_order.purchase_payments",
              "sale_items.purchase_order.customer",
              "sale_items.purchase_order.farmer",
              "sale_items.purchase_item.purchase_order.customer",
              "sale_items.purchase_item.purchase_order.farmer",
              "sale_items.trip_item.purchase_item",
              "sale_items.trip_item.purchase_order.customer",
              "sale_items.trip_item.purchase_order.farmer",
              "ticket",
              "trip.purchase_order",
              "trip.customer",
              "trip.driver",
              "trip.vehicle",
              "sales_reports",
              "sale_payments"
            ].join(","),
            ...this.$route.params,
            ...this.filterParams
          }
        })
        .then(response => {
          const {
            data: { data, meta, aggregate }
          } = response;
          this.models = data.map(datum => {
            let purchaseOrders = [];
            datum.sale_items.forEach(saleItem => {
              if (!this.lodash.isEmpty(saleItem.purchase_item)) {
                purchaseOrders.push(saleItem.purchase_item.purchase_order);
              }
            });
            const purchaseOrderPartner = this.purchaseOrderPartnerName(purchaseOrders);
            return {
              ...datum,
              ...this.modelPolicy(datum),
              purchase_order_partner_name: purchaseOrderPartner,
              partner_names: this.partnerNames(purchaseOrderPartner, datum),
              purchase_order_ordered_at: this.purchaseOrderOrderedAt(purchaseOrders)
            };
          });

          this.page = Number(meta.current_page);
          this.perPage = Number(meta.per_page);
          this.from = Number(meta.from);
          this.total = Number(meta.total);
          this.latest_ordered_at = aggregate.latest_ordered_at;
          this.oldest_ordered_at = aggregate.oldest_ordered_at;

          this.stats = [
            {
              title: this.lodash.startCase(this.$t("sale_notes.count")),
              value: this.$numeral(this.total).format("0,0"),
              valueTitle: this.$numeral(this.total).format("0,0"),
              wrapperClass: "col-12 col-md-6 col-xl-4",
              component: StatusWidget
            },
            {
              title: this.lodash.startCase(this.$t("sale_notes.total_quantity")),
              value: `${this.$numeral(meta.total_quantity / 1000).format("0,0.[00]")}`,
              valueTitle: `${this.$numeral(meta.total_quantity / 1000).format("0,0.[00]")}`,
              wrapperClass: "col-12 col-md-6 col-xl-4",
              // class: 'pb-3',
              component: StatusTonWidget
            },
            {
              title: this.lodash.startCase(this.$t("sale_notes.total_revenue")),
              value: this.$numeral(meta.total_revenue).format("0,0.[00]"),
              valueTitle: this.$numeral(meta.total_revenue).format("$ 0,0.[00]"),
              wrapperClass: "col-12 col-md-12 col-xl-4",
              component: StatusDateWidget
            }
          ];

          return response;
        })
        .catch(error => this.failedAlert(error));
    },
    handleExport(typeFile) {
      if (typeFile === "pdf") {
        this.handleExportPDF();
      } else if (typeFile === "excel") {
        this.handleExportExcel();
      }
    },
    handleExportExcel() {
      if (this.models.length === 0) {
        return this.noDataToExportConfirmAlert();
      } else if (!this.isOrderedAtInMonth(3)) {
        return this.exportMoreThanThreeMonthConfirmAlert();
      }

      let exportParams = {
        search: this.search,
        sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        with: [
          "customer",
          "odoo_sale_order",
          "purchase_order.customer",
          "purchase_order.farmer",
          "purchase_order.purchase_payments",
          "sale_items.purchase_order.customer",
          "sale_items.purchase_order.farmer",
          "sale_items.purchase_item.purchase_order.customer",
          "sale_items.purchase_item.purchase_order.farmer",
          "sale_items.trip_item.purchase_item",
          "sale_items.trip_item.purchase_order.customer",
          "sale_items.trip_item.purchase_order.farmer",
          "ticket",
          "trip.customer",
          "trip.driver",
          "trip.vehicle"
        ].join(","),
        ...this.$route.params,
        ...this.filterParams
      };

      this.loadingExportExcel = true;
      return this.$axios
        .get("/sale_orders_export_excel", {
          responseType: "blob",
          params: exportParams
        })
        .then(res => {
          // create file link in browser's memory
          const href = URL.createObjectURL(res.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", `Sales Recap - ${this.exportDatesLabel}.xlsx`); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          return res;
        })
        .catch(error => {
          if (error.status === 200 && error.data.length === 0) {
            return Swal.fire({
              title: this.$t("Warning") + "!",
              text: this.lodash.upperFirst(
                this.$t("sale_notes.exports.validations.there is no data to export between {something}", {
                  something: this.exportDatesLabel
                })
              ),
              type: "warning",
              confirmButtonClass: "btn btn-warning btn-fill",
              buttonsStyling: false
            });
          }
          return Swal.fire({
            title: this.lodash.startCase(this.$t("failed")),
            text: this.lodash.upperFirst(this.$t("download_failed")),
            type: "danger",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        })
        .finally(res => {
          this.loadingExportExcel = false;
          return res;
        });
    },
    handleExportPDF() {
      this.$bvModal.show("sales-report-export-modal");
    },
    hideExportModal() {
      this.$refs["export-modal"].hide();
    },
    showExportModal() {
      this.$refs["export-modal"].show();
    },
    checkExportFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.orderedAtState = valid;
      return valid;
    },
    handleExportOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleExportSubmit() {
      // Exit when the form isn't valid
      if (!this.checkExportFormValidity()) {
        return;
      }
      // Push the name to submitted names
      this.submittedNames.push(this.name);
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
    onSubmitExport() {
      this.loadingExport = true;
      let exportParams = {
        search: this.search,
        sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        with: [
          "customer",
          "purchase_order.customer",
          "purchase_order.farmer",
          "purchase_order.purchase_payments",
          "sale_items.purchase_order.customer",
          "sale_items.purchase_order.farmer",
          "sale_items.purchase_item.purchase_order.customer",
          "sale_items.purchase_item.purchase_order.farmer",
          "sale_items.trip_item.purchase_item",
          "sale_items.trip_item.purchase_order.customer",
          "sale_items.trip_item.purchase_order.farmer",
          "ticket",
          "trip.customer",
          "trip.driver",
          "trip.vehicle"
        ].join(","),
        ...this.$route.params,
        ...this.filterParams,
        ordered_at__between: this.exportOrderedAt.map(value => this.$moment(value).format("YYYY-MM-DD")).join(",")
      };
      return this.$axios
        .get("/sale_orders", {
          params: exportParams
        })
        .then(res => {
          let {
            data: {
              data,
              meta: { total }
            }
          } = res;

          if (total === 0) {
            throw {
              status: 200,
              data
            };
          }

          return this.$axios.get(
            this.activePillButton === "pdf" ? "/sale_orders_export" : "/sale_orders_export_excel",
            {
              responseType: "blob",
              params: exportParams
            }
          );
        })
        .then(res => {
          // create file link in browser's memory
          const href = URL.createObjectURL(res.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute(
            "download",
            `Sales Recap - ${this.exportDatesLabel}${this.activePillButton === "pdf" ? ".pdf" : ".xlsx"}`
          ); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          return res;
        })
        .catch(error => {
          if (error.status === 200 && error.data.length === 0) {
            return Swal.fire({
              title: this.$t("Warning") + "!",
              text: this.lodash.upperFirst(
                this.$t("sale_notes.exports.validations.there is no data to export between {something}", {
                  something: this.exportDatesLabel
                })
              ),
              type: "warning",
              confirmButtonClass: "btn btn-warning btn-fill",
              buttonsStyling: false
            });
          }
          return Swal.fire({
            title: this.lodash.startCase(this.$t("failed")),
            text: this.lodash.upperFirst(this.$t("download_failed")),
            type: "danger",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        })
        .finally(res => {
          this.loadingExport = false;
          return res;
        });
    },
    isOrderedAtInMonth(value = 3) {
      return this.$moment(this.latest_ordered_at).diff(this.$moment(this.oldest_ordered_at), "months", true) <= value;
    },
    modelPolicy() {
      let modelPolicy = {
        _denyShow: false,
        _denyEdit: true,
        _denyDelete: true
      };

      // if (["unload", "cash", "harvest", "deposit_goods", "local_market"].includes(model.type)) {
      //   modelPolicy._denyEdit = true;
      // } else {
      //   modelPolicy._denyEdit = !this.$auth.hasPermissionTo("sale_reports.edit");
      // }

      return {
        ...modelPolicy
      };
    },
    purchaseOrderPartnerName(purchaseOrders) {
      let uniquerCustomers = [...new Set(purchaseOrders.map(purchaseOrder => purchaseOrder.customer?.name))];

      if (uniquerCustomers.length > 1) return `${uniquerCustomers[0]}, ${this.$t("et_al")}`;
      else if (uniquerCustomers.length === 1) return uniquerCustomers[0];
      else return "-";
    },
    partnerNames(purchaseOrderPartner, saleOrder) {
      let processingPartner = saleOrder.buyer_name || saleOrder.trip?.customer?.name || null;
      if (saleOrder.type === "hybrid") processingPartner = saleOrder.buyer_name;
      if (!processingPartner) return purchaseOrderPartner;
      return `${purchaseOrderPartner} ke ${processingPartner}`;
    },
    purchaseOrderOrderedAt(purchaseOrders) {
      return [...new Set(purchaseOrders.map(purchaseOrder => purchaseOrder.ordered_at))];
    },
    saleOrderInformation(saleOrder) {
      let text = null;

      if (saleOrder.ticket?.customer_type === "brs") {
        text = saleOrder?.buyer_name;
      } else {
        if (saleOrder.is_unload_order) {
          text = saleOrder?.trip?.customer?.name;
        } else if (saleOrder.type === "local_market") {
          text = saleOrder?.customer?.name;
        }
      }
      return text;
    },
    noDataToExportConfirmAlert() {
      return Swal.fire({
        title: this.$t("Warning") + "!",
        text: this.lodash.upperFirst(this.$t("sale_notes.exports.validations.there is no data to export")),
        type: "warning",
        confirmButtonClass: "btn btn-warning btn-fill",
        buttonsStyling: false
      });
    },
    exportMoreThanThreeMonthConfirmAlert() {
      return Swal.fire({
        title: `<span style="font-size: 18px;font-weight: 700;line-height: 22px;letter-spacing: 0;">${this.$t(
          "Warning"
        )}!</span>`,
        html: `${this.lodash.upperFirst(this.$t("sale_notes.exports.validations.ordered_at"))}<br>${this.$t(
          "sale_notes.exports.validations.Please change the {something} filter first",
          {
            something: this.$t("sale_notes.sales_date")
          }
        )}`,
        type: "warning",
        confirmButtonClass: "btn btn-primary btn-fill sweet-alert-font",
        confirmButtonText: `<span style="font-size: 14px;line-height: 16px;letter-spacing: 0em;text-align: center;">${this.lodash.upperFirst(
          this.$t("sale_notes.exports.validations.ok")
        )}</span>`,
        buttonsStyling: false,
        color: "#30345B",
        customClass: {
          container: "export-sweet-alert"
        }
      });
    },
    getValidationState({dirty, validated, valid = null}) {
      return dirty || validated ? valid : null;
    },
    handleSyncToOdoo(order) {
      this.busy = true
      return this.$axios.post(`/sale_orders/${order.id}/sync_to_odoo`)
          .then(() => {
            return Swal.fire({
              icon: "success",
              title: this.$t("odoo_sync_messages.add_{order}_to_queue_title", {order: this.lodash.startCase(this.$t(`${this.resourceRoute}.singular`))}),
              text: this.$t("odoo_sync_messages.add_{id}_{order}_to_queue_successfully", {
                id: order.id,
                order: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.singular`)),
              }),
              type: 'success',
              showConfirmButton: true,
              confirmButtonText: this.$t("Understood"),
            })
          })
          .catch(error => {
            return Swal.fire({
              title: this.$t('Failed') + '!',
              text: (error.response && (error.response.data || {}).message) || error.message,
              type: 'danger',
              confirmButtonClass: 'btn btn-danger btn-fill',
              buttonsStyling: false
            })
          }).finally(() => {
            this.busy = false
            this.$router.go(0)
          })
    }
  }
};
</script>

<style>
body {
  max-width: 100vw !important;
  overflow-x: hidden !important;
}
</style>

<style scoped lang="scss">
::v-deep {
  table tbody tr {
    * {
      font-size: 14px !important;
    }
  }
  .page-content {
    background: #eef3f7 !important;
    font-family: Lato;
    color: #161b4d;
  }

  .text-right {
    text-align: right;
  }
  .utility-button {
    border-radius: 8px;
    padding: 10px 13px;
    font-size: 13px;
  }
  button:focus {
    box-shadow: 0 0 0 0.25rem rgba(0, 0, 0, 0.1) !important;
  }
  .btn-export-file {
    background-color: #f5f6f7;
    color: #454646 !important;
    border-color: #f5f6f7;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0;

    &.active {
      color: white !important;
    }
    &.btn-excel.active {
      background-color: #4cb244;
    }
    &.btn-pdf.active {
      background-color: #f14250;
    }
  }
  .btn-excel.active {
    background-color: #4cb244;
    color: white;
  }
  .btn-pdf.active {
    background-color: #f14250;
    color: white;
  }
  .export-feedback {
    font-family: Lato;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0;
    text-align: left;
  }
}
</style>
